module.exports = __webpack_public_path__ + "img/error_bg.255d420f.jpg";